<template>
  <el-container>
    <div class="g-aside-main">
      <el-form :inline="true" @submit.native.prevent>
        <el-row type="flex">
          <el-col style="text-align: left">
            <el-button @click="goBack"> 返回 </el-button>
          </el-col>
          <el-col style="text-align: right">
            <el-form-item label="选择考试">
              <ksList
                :value.sync="ksObj"
                :ksid.sync="ksid"
                @change="query()"
              ></ksList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px" v-if="ksObj">
          <el-col :span="6"> 考试名称：{{ ksObj.ksmc }} </el-col>
          <el-col :span="6"> 考试时间：{{ ksObj.djsj }} 分钟 </el-col>
          <el-col :span="6"> 试卷总分：{{ ksObj.zf }} 分 </el-col>
          <el-col :span="6"> 及格分： {{ ksObj.jgfs }} 分 </el-col>
        </el-row>
        <el-row type="flex">
          <el-col> 考生考试成绩 </el-col>
          <el-col style="text-align: right; padding-bottom: 5px">
            <el-button
              type="primary"
              style="color: white"
              @click="exportScoreExcel"
            >
              导出成绩
            </el-button>
            <el-button
              type="primary"
              style="color: white"
              @click="exportAnswerExcel"
            >
              导出作答明细
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="yun-shadow">
        <el-table :data="tableData" style="width: 100%" :border="true">
          <el-table-column label="考生" width="120" prop="ksxm" />
          <el-table-column label="部门" width="200" prop="bm" />
          <el-table-column label="分数" width="80" prop="fs" align="right" />
          <el-table-column label="排名" width="80" prop="pm" align="right" />
          <el-table-column label="错题数" width="80" prop="cts" align="right" />
          <el-table-column
            label="答题时长"
            width="100"
            prop="dtsc"
            align="center"
          />
          <el-table-column label="开卷时间" width="170" prop="kjsj" />
          <el-table-column label="交卷时间" width="170" prop="jjsj" />
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </el-container>
</template>
<script>
import * as report from '@/api/report'
import { baseURL } from '@/assets/js/config'
import ksList from '@/components/select/ksList'
export default {
  data () {
    return {
      ksid: Number(this.$route.query.ksid),
      ksObj: {
        ksid: ''
      },
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: []
    }
  },
  components: {
    ksList
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/exam/list'
      })
    },
    // 导出考试成绩
    exportScoreExcel () {
      const params = 'ksid=' + this.ksObj.ksid
      const ksname = this.ksObj.ksmc
      // 后台数据下载不能用ajqx请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('GET', baseURL + '/report/examScoreExport?' + params, true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求陈宫返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          const filename = ksname + '考试成绩.xls'
          const a = document.createElement('a')
          // 创键临时url对象
          const url = URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url)
        }
      }
      xmlhttp.send()
    },
    exportAnswerExcel () {
      const that = this
      const params = 'ksid=' + this.ksObj.ksid
      const ksname = this.ksObj.ksmc
      // 后台数据下载不能用ajqx请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('GET', baseURL + '/report/examAnswerExport?' + params, true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          // 如果返回的是json 则说明是报错了
          if (blob.type === 'application/json') {
            blob.text().then(data => {
              const res = JSON.parse(data)
              that.$message.error(res.msg)
            })
          } else {
            const filename = ksname + '考试作答明细.xls'
            const a = document.createElement('a')
            // 创键临时url对象
            const url = URL.createObjectURL(blob)
            a.href = url
            a.download = filename
            a.click()
            // 释放之前创建的URL对象
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xmlhttp.send()
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询考试成绩
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign(
        { pageNo: this.currentPage, pageSize: this.pageSize },
        {}
      )
      params.ksid = this.ksObj.ksid
      // params.ksid = ''
      report.examScoreList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    }
  }
}
</script>
